import { IArticleCard } from './articleCard.models';
import { ArticleCardSmall } from './components/ArticleCardSmall/articleCardSmall';
import { ArticleCardLarge } from './components/ArticleCardLarge/articleCardLarge';

const ArticleCard = ({
  title,
  topic,
  creator,
  backgroundImg,
  pillText,
  variant = 'small',
  isExternalImages,
  ignoreSize,
  blurredBackgroundImg,
}: IArticleCard) => (
  <>
    {variant === 'small' && (
      <ArticleCardSmall
        title={title}
        topic={topic}
        creator={creator}
        backgroundImg={backgroundImg}
        blurredBackgroundImg={blurredBackgroundImg}
        pillText={pillText}
        isExternalImages={isExternalImages}
        ignoreSize={ignoreSize}
      />
    )}
    {variant === 'large' && (
      <ArticleCardLarge
        title={title}
        topic={topic}
        creator={creator}
        backgroundImg={backgroundImg}
        blurredBackgroundImg={blurredBackgroundImg}
        pillText={pillText}
        isExternalImages={isExternalImages}
        ignoreSize={ignoreSize}
      />
    )}
  </>
);
export default ArticleCard;
